"use client";
import { useState as i, useRef as c, useEffect as l } from "react";
const d = (e) => e == null ? void 0 : e.closest('[data-comp="portal"]'), E = ({
  eventIn: e,
  eventOut: t
}) => {
  const [u, r] = i(!1), o = c(null), n = {
    mouseover: () => r(!0),
    mouseout: () => r(!1),
    mousedown: (s) => {
      o.current && o.current !== s.target && !d(s.target) && r(!1);
    }
  };
  return l(() => {
    const s = o.current;
    if (s)
      return s.addEventListener(e, n[e]), document.addEventListener(t, n[t]), () => {
        s.removeEventListener(e, n[e]), document.removeEventListener(t, n[t]);
      };
  }, [o.current]), [o, u];
};
export {
  E as default
};
